<arm-layout>
  <div header>
    <div class="search-container">
      <client-filter (onFilter)="onFilter($event)"></client-filter>
    </div>
    <div class="action-buttons">

      <arm-action-bar (addClick)="addItem()" [disableAdd]="isUnauthorized"
                      (editClick)="editItem()" [disableEdit]="isUnauthorized || !selection"
                      (deleteClick)="removeItem()" [disableDelete]="isUnauthorized || !selection"
                      (refreshClick)="refresh()"></arm-action-bar>
    </div>
  </div>


  <div main>
    <arm-table [data]="items" (onSelection)="select($event)"
               [displayedColumns]="displayedColumns" [isMultipleSelection]="false"
               [isClientSide]="true" [filter]="filter"></arm-table>
  </div>
</arm-layout>
